import { ModuleWithProviders } from '@angular/core';
// https://angular.io/styleguide#!#04-10
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule
        };
    };
    return SharedModule;
}());
export { SharedModule };
